import React from 'react';
import { H3, NamedLink } from '../../../components';
import { REVIEW_LISTING_TYPE, NEWS_LISTING_TYPE, GUIDE_LISTING_TYPE } from '../../../util/types';
import css from './ArticleCard.module.css';

const LISTING_TYPE_LABELS = {
  [REVIEW_LISTING_TYPE]: 'Review',
  [NEWS_LISTING_TYPE]: 'News',
  [GUIDE_LISTING_TYPE]: 'Guide',
};

// Regular Article Card Component
const ArticleCard = ({ listing, intl, config }) => {
  const { title, publicData } = listing.attributes;
  const author = listing.author?.attributes?.profile?.displayName || intl.formatMessage({ id: 'ArticlesPage.unknownAuthor' });
  const createdAt = listing.attributes.createdAt;
  const formattedDate = intl.formatDate(createdAt, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
  const firstImage = listing.images && listing.images.length > 0 ? listing.images[0] : null;
  const listingType = publicData?.listingType;
  const typeLabel = LISTING_TYPE_LABELS[listingType];
  return (
    <NamedLink
      name="ListingPage"
      params={{ id: listing.id.uuid, slug: listing.attributes.title }}
      className={css.articleCard}
    >
      {firstImage && (
        <div className={css.articleImageWrapper}>
          <div className={css.aspectWrapper}>
            <img
              src={firstImage.attributes.variants['scaled-medium']?.url || firstImage.attributes.variants['default']?.url}
              alt={title}
              className={css.articleImage}
            />
          </div>
        </div>
      )}
      <div className={css.articleContent}>
        <H3 as="h3" className={css.articleTitle}>
          {title}
        </H3>
        <div className={css.articleMeta}>
          <span className={css.author}>{author}</span>
          <span className={css.separator}>-</span>
          <span className={css.date}>{formattedDate}</span>
          {typeLabel && (
            <span className={`${css.typeTag} ${css[`typeTag_${listingType}`]}`}>
              {typeLabel}
            </span>
          )}
        </div>

      </div>

    </NamedLink>
  );
};

export default ArticleCard;